export default __webpack_public_path__ + "static/media/Image1.004a82e7.jpeg";